const STATIC_URL = window.static_url
  ? window.static_url
  : null

const ENDPOINT_CATEGORIES = 'categories/'
const ENDPOINT_DECORATION_ASSET = 'decoration-assets/'
const ENDPOINT_ITEMS = 'items/'
const ENDPOINT_PRODUCTS = 'products/'
const ENDPOINT_VARIANTS = 'variants/'

const BY_CATEGORY = '?category_id='
const BY_ITEM_ID = '?item_id='
const BY_PRODUCT_ID = '?product_id='
const BY_TEMPLATE_ID = '?template_id='

const BY_W = 'width='
const BY_H = 'height='

export {
  STATIC_URL,
  ENDPOINT_CATEGORIES,
  ENDPOINT_DECORATION_ASSET,
  ENDPOINT_ITEMS,
  ENDPOINT_PRODUCTS,
  ENDPOINT_VARIANTS,

  BY_CATEGORY,
  BY_ITEM_ID,
  BY_PRODUCT_ID,
  BY_TEMPLATE_ID,

  BY_W,
  BY_H
}



// WEBPACK FOOTER //
// ./uncommon-client/api/endpoints.js